import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import ChallengeDetails from './ChallengeDetails';
import GameProp from './propTypes/gameProp';
import { CHALLENGE_TABS } from '../../services/utilityFunctions';
import AppProductProp from '../profile/propTypes/appProductProp';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import StripeCardProp from '../profile/propTypes/StripeCardProp';
import translate from '../../commonComponents/translate';
import CurrencyProp from '../profile/propTypes/currencyProp';

function ChallengeDetailsWrapper(props) {
  const { t, challenge, cards, appProducts, countries, activeTab, _csrf, pspdfkitLicenseKey, currencies } = props;
  return (
    <Title title={t('challengeDetails_head_title')}>
      <ContentContainer>
        <SubHeader
          title={challenge.name}
        />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <ChallengeDetails
                challenge={challenge}
                cards={cards}
                appProducts={appProducts}
                countries={countries}
                activeTab={activeTab}
                _csrf={_csrf}
                pspdfkitLicenseKey={pspdfkitLicenseKey}
                currencies={currencies}
              />
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

ChallengeDetailsWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  challenge: PropTypes.shape(GameProp.propType).isRequired,
  activeTab: PropTypes.oneOf(CHALLENGE_TABS).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  _csrf: PropTypes.string.isRequired,
  pspdfkitLicenseKey: PropTypes.string,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)).isRequired,
};

ChallengeDetailsWrapper.defaultProps = {
  pspdfkitLicenseKey: null,
};

export default translate(ChallengeDetailsWrapper);
